import { MatchingCommandType, MatchingInterviewLocationType, MatchingMessageSenderType, MatchingMessageType, PhsAccType } from 'consts/MatchingMessageType';

export enum MatchingMessageProposalType {
  SIMILAR = 'SIMILAR',
  DELIVERY_PROPOSAL = 'DELIVERY_PROPOSAL',
}

export enum MatchingMessageResponseType {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  UNANSWERED = 'UNANSWERED',
}

export interface IMatchingTalkMessageOptionDto {
  action: string; // 메세지 선택지 내용
  command: string; // 선택옵션 유형
  sn: number;
  title: string;
  disabled: boolean; // 메시지 선택지 선택불가 여부 (면접 일정 이미 선택)
  interviewLocation?: string;
}

export interface IMessageAttachFileDto {
  fileUid: string;
  fileName: string;
  fileSize: number;
}

export interface IMatchingTalkApplyMessageDto {
  applyType: PhsAccType;
  applySn: number;
  code: string;
}
export interface IMatchingTalkMessageDto {
  sn: number;
  command: MatchingCommandType;
  sendDateTime: string;
  decision: IMatchingTalkMessageOptionDto;
  decisionDateTime: string;
  decisionDueDateTime: string;
  message: string;
  messageType: MatchingMessageType;
  options: IMatchingTalkMessageOptionDto[];
  userAttachFiles: IMessageAttachFileDto[];
  companyAttachFiles: IMessageAttachFileDto[];
  sender: MatchingMessageSenderType;
  title: string;
  interviewLocationType: MatchingInterviewLocationType;
  interviewLocation: string;
  submitApplies: IMatchingTalkApplyMessageDto[];
}

export interface IMatchingMessageRs {
  command: MatchingCommandType;
  sendDateTime: string;
  decision: IMatchingTalkMessageOptionDto;
  decisionDateTime: string;
  decisionDueDateTime: string;
  message: string;
  messageType: MatchingMessageType;
  options: IMatchingTalkMessageOptionDto[];
  userAttachFiles: IMessageAttachFileDto[];
  companyAttachFiles: IMessageAttachFileDto[];
  sender: MatchingMessageSenderType;
  title: string;
  interviewLocationType: MatchingInterviewLocationType;
  interviewLocation: string;
}

export interface IMatchingHdotXMessageRs {
  title: string;
  content: string;
  proposalType: MatchingMessageProposalType;
  companyLogoUrl: string;
  offerReceivedDateTime: string;
  responseLimitDateTime: string;
  companyName: string;
  responseType: MatchingMessageResponseType;
  responseDateTime: string | null;
  rejectReason:string;
  jobDescription: {
    title: string;
    descriptions: string[];
    requiredSkills: string[];
    preferredSkills: string[];
  };
    }
export default interface IMatchingMessageListRs {
  messages: IMatchingTalkMessageDto[];
  positionName: string;
  companyName: string;
  companySn:number;
  logoImageUrl: string;
  openYn: boolean;
  deleteYn: boolean;
  endDateTime: string;
  deleteDateTime: string;
  closingDateTime: string;
}
